'use client';
import React from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@design-system';

type Props = {
  locale: string;
  supportedLocales: string[];
};

function replaceLocale(currentLocale: string, selectedLocale: string): void {
  const searchParams = window.location.search;
  const newPathname = window.location.pathname.replace(new RegExp(`^/${currentLocale}`), `/${selectedLocale}`);
  window.location.href = `${newPathname}${searchParams}`;
}

export function LanguageSelector({ locale, supportedLocales }: Props): React.JSX.Element {
  const handleValueChange = (selectedLocale: string): void => {
    replaceLocale(locale, selectedLocale);
  };
  return (
    <Select onValueChange={handleValueChange}>
      <SelectTrigger className="w-[80px]">
        <SelectValue placeholder={locale.toUpperCase()} />
      </SelectTrigger>

      <SelectContent>
        {supportedLocales.map((supportedLocale) => (
          <SelectItem key={supportedLocale} value={supportedLocale}>
            {supportedLocale.toUpperCase()}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
